"use client";

import { ArrowRightLeft, ShieldCheck, X } from "lucide-react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { CallbackForm } from "@/components/callback-form";
import { Sky } from "@/components/sections/sky/sky-ui";
import { useDemoPopup } from "@/contexts/demo-popup-context";

export function DemoPopup() {
  const { isOpen, closePopup, markAsSubmitted, source } = useDemoPopup();

  return (
    <Dialog open={isOpen} onOpenChange={closePopup}>
      <DialogContent
        showCloseButton={false}
        className="overflow-hidden rounded-[28px] p-0 shadow-[0_40px_100px_-30px_rgba(2,26,158,0.6)] ring-1 ring-black/5 sm:max-w-[460px]"
      >
        {/* -m-6 znosi wewnętrzny padding DialogContent — nagłówek na niebie od krawędzi do krawędzi */}
        <div className="-m-6">
          <div className="relative overflow-hidden px-6 pb-7 pt-7 text-white md:px-8">
            <Sky variant="page" />
            <DialogClose
              className="absolute right-4 top-4 z-10 grid h-9 w-9 place-items-center rounded-full bg-white/15 text-white ring-1 ring-white/30 transition hover:bg-white/25 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
              aria-label="Zamknij"
            >
              <X className="h-4 w-4" />
            </DialogClose>
            <div className="relative pr-9">
              <DialogTitle className="text-2xl font-bold leading-tight tracking-tight text-white">
                Zostaw numer — oddzwonimy
              </DialogTitle>
              <DialogDescription className="mt-2 text-[15px] leading-relaxed text-white/90">
                15 sekund Twojego czasu. Resztę załatwimy w rozmowie.
              </DialogDescription>
            </div>
            <div className="relative mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1 text-xs font-semibold text-primary">
                <ShieldCheck className="h-3.5 w-3.5" />
                Bez zobowiązań
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1 text-xs font-semibold text-primary">
                <ArrowRightLeft className="h-3.5 w-3.5" />
                0 zł za migrację
              </span>
            </div>
          </div>

          <div className="px-6 pb-6 pt-6 md:px-8 md:pb-8">
            <CallbackForm source={source ?? "popup"} onSuccess={markAsSubmitted} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
